export default __webpack_public_path__ + "static/media/envelope.cfb7e6aa.svg";